import gaEvents from '~js/ga-events'

const state = {
  isAppReady: false,
  isScreenReady: false,
  isSomethingWrong: false,
  isPropertyNotFound: false,
  isBuildingNotFound: false,
  isNoPanoramasFound: false
}

export const getters = {
  isAppReady: state => state.isAppReady,
  isScreenReady: state => state.isScreenReady,
  isSomethingWrong: state => state.isSomethingWrong,
  isPropertyNotFound: state => state.isPropertyNotFound,
  isBuildingNotFound: state => state.isBuildingNotFound,
  isNoPanoramasFound: state => state.isNoPanoramasFound
}

export const actions = {
  setAppReady ({ commit }, bool = false) {
    commit('SET_APP_READY', bool)
  },

  setSomethingWrong ({ commit, state, rootState }, bool = false) {
    gaEvents.sendEvent('Building', 'SomethingWrong', rootState.route.params.buildingId || rootState.buildings.currentBuilding.objectId || '')
    commit('SET_SOMETHING_WRONG', bool)
  },

  setPropertyNotFound ({ commit, state, rootState }, bool = false) {
    if (state.isPropertyNotFound === false && bool === true) {
      gaEvents.sendEvent('Property', 'ShowPropertyNotFound', rootState.route.query.group || rootState.property.property.objectId || '')
    }
    commit('SET_PROPERTY_NOT_FOUND', bool)
  },

  setBuildingNotFound ({ commit, state, rootState }, bool = false) {
    if (state.isBuildingNotFound === false && bool === true) {
      gaEvents.sendEvent('Building', 'ShowBuildingNotFound', rootState.route.params.buildingId || rootState.buildings.currentBuilding.objectId || '')
    }
    commit('SET_BUILDING_NOT_FOUND', bool)
  },

  setPanoramasNotFound ({ commit, state, rootState }, bool = false) {
    if (state.isNoPanoramasFound === false && bool === true) {
      gaEvents.sendEvent('Building', 'ShowPanoramasNotFound', rootState.route.params.buildingId || rootState.buildings.currentBuilding.objectId || '')
    }
    commit('SET_PANORAMAS_NOT_FOUND', bool)
  },

  setScreenReady ({ dispatch, commit, rootState }, bool = false) {
    commit('SET_SCREEN_READY', bool)
  }
}

export const mutations = {
  SET_APP_READY (state, bool = false) {
    state.isAppReady = bool
  },

  SET_SOMETHING_WRONG (state, bool = false) {
    state.isSomethingWrong = bool
  },

  SET_SCREEN_READY (state, bool = false) {
    state.isScreenReady = bool
  },

  SET_PROPERTY_NOT_FOUND (state, bool = false) {
    state.isPropertyNotFound = bool
  },

  SET_BUILDING_NOT_FOUND (state, bool = false) {
    state.isBuildingNotFound = bool
  },

  SET_PANORAMAS_NOT_FOUND (state, bool = false) {
    state.isNoPanoramasFound = bool
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
